var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"block-constructor"},[_c('content-block-canvas',{attrs:{"parent-id":null,"can-edit":_vm.canEdit}}),(_vm.canEdit)?_c('content-block-pallete'):_vm._e(),(_vm.canEdit)?_c('content-block-configurator'):_vm._e(),(_vm.canEdit)?_c('content-block-model-editor'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }